var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "title": "Contact Us",
            "src": "/images/sub/sub-visual.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first pb-0"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [_vm._l(_vm.ko, function (item, index) {
    return [index !== 0 ? _c('v-col', {
      key: index,
      staticClass: "d-none d-lg-flex align-self-strech ml-n1px",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-divider', {
      staticClass: "h-100 border-dark",
      attrs: {
        "vertical": ""
      }
    })], 1) : _vm._e(), _c('v-col', {
      key: index,
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": 100 * (index + 1),
        "cols": "12",
        "sm": "6",
        "md": "4",
        "lg": ""
      }
    }, [_c('div', {
      staticClass: "text-center"
    }, [_c('v-img', {
      staticClass: "mx-auto mb-10px",
      attrs: {
        "max-width": "36",
        "src": item.icon,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "tit tit--xs line-height-1"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "pt-16px pt-md-20px"
    }, [item.address ? [_c('p', {
      staticClass: "txt",
      domProps: {
        "innerHTML": _vm._s(item.address)
      }
    })] : _vm._e(), item.tel ? [_c('a', {
      staticClass: "txt grey--text text-decoration-underline",
      attrs: {
        "href": `tel:${item.tel}`
      }
    }, [_vm._v(" " + _vm._s(item.tel) + " ")])] : _vm._e(), item.email ? [_c('a', {
      staticClass: "txt grey--text text-decoration-underline",
      attrs: {
        "href": `mailto:${item.email}`
      }
    }, [_vm._v(" " + _vm._s(item.email) + " ")])] : _vm._e(), item.apps ? [_c('v-row', {
      staticClass: "row--sm",
      attrs: {
        "align": "center",
        "justify": "center"
      }
    }, _vm._l(item.apps, function (app, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "auto"
        }
      }, [_c('a', {
        attrs: {
          "href": app.link,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "30",
          "aspect-ratio": 1 / 1,
          "src": app.icon,
          "alt": item.name
        }
      })], 1)]);
    }), 1)] : _vm._e()], 2)], 1)])];
  })], 2)], 1), _c('page-section', {
    staticClass: "page-section--sm"
  }, [_c('v-img', {
    attrs: {
      "data-aos": "fade",
      "src": "/images/sub/contact/map.png",
      "alt": ""
    }
  })], 1), _c('page-section', {
    staticClass: "page-section--last pt-0"
  }, [_c('div', {
    staticClass: "pb-16px pb-md-20px"
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("상담 신청")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs text-right"
  }, [_c('span', {
    staticClass: "red--text"
  }, [_vm._v("* ")]), _vm._v("기입필수")])])], 1)], 1), _c('form-input', {
    attrs: {
      "skin": "inquiries"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }